import {Component, OnInit} from '@angular/core';
import {MatCardModule} from '@angular/material/card';

@Component({
    selector: 'eaglei-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    imports: [MatCardModule],
})
export class TermsOfUseComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
